import { useQuery } from 'react-query';

import { PageContentDto } from './types';
import { GET_PAGE_CONTENTS_QUERY_KEY } from './utils';
import { api } from '../../utils';

export interface UsePostEnrollCoverageQueryProps {
  lookupCode: string;
  coverageId?: number;
  orgInfoBenId?: number;
}

export const usePostEnrollCoverageQuery = ({
  lookupCode,
  coverageId,
  orgInfoBenId,
}: UsePostEnrollCoverageQueryProps) => {
  const {
    data: pageContent,
    isLoading: isLoadingPageDetails,
    isFetching: isFetchingPageDetails,
  } = useQuery<PageContentDto>(
    GET_PAGE_CONTENTS_QUERY_KEY(lookupCode, coverageId, orgInfoBenId),
    () =>
      api.get('/page_content', {
        page_content_lookup_code: lookupCode,
        coverage_id: coverageId,
        org_informational_benefit_id: orgInfoBenId,
      }),
    { enabled: Boolean(coverageId || orgInfoBenId) }
  );
  return { pageContent, isLoadingPageDetails, isFetchingPageDetails };
};
